import EditRosterWrapper from "../common/EditRosterWrapper";

function EditRoster() {
  return <EditRosterWrapper rosterType="secondary" />;
}

export default EditRoster;
